import { render } from "./NotificacaoForm.vue?vue&type=template&id=491bace6"
import script from "./NotificacaoForm.vue?vue&type=script&lang=js"
export * from "./NotificacaoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__